import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MatchService } from './services/match.service';
import { Subject } from 'rxjs';
import { SocketIoModule } from 'ngx-socket-io';
import { configSocketIO } from 'src/environments/environment';
import { DirectivesModule } from '@shared/utils/directives.module';
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from 'src/app/global-error-handler';
import { VegmatchModalComponent } from './shared/components/vegmatch-modal/vegmatch-modal.component';
import { AvocadoModalComponent } from './shared/components/fyra-plus-modal/avocado-modal.component';
import { SharedModule } from '@shared/components/shared.module';
import { ConnectionRetryInterceptor } from '@shared/services/connection-retry.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    VegmatchModalComponent,
    AvocadoModalComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot({innerHTMLTemplatesEnabled: true}),
    AppRoutingModule,
    DirectivesModule,
    HammerModule,
    HttpClientModule,
    SocketIoModule.forRoot(configSocketIO),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConnectionRetryInterceptor,
      multi: true
    },
    MatchService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  public static superLikeSubject = new Subject<number>();
}

